module.exports = __webpack_public_path__ + "static/car-89097bdcf5d13c8ceadcc2f3989fa976.jpg";